<!--- COMPONENTE PCIncidenciasPedidosPlanificacion  ---->
<!---
CASO DE USO: https://grupohispatec.sharepoint.com/:w:/s/Produccin/EQGVtEI-QZBGn5mlWlmWKuoBpbhZcHXi7Y9UhT25hgCQpQ?e=keizgg
Descripción del componente:
---------------------------

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="main-pcIncidenciasPedidosPlanificacion">
    <!-- <pre> {{ incidentsCurrentLine }} </pre> -->
    <div class="content-card-list">
      <f7-card
        v-for="(item, index) in incidentsCurrentLine"
        :key="index"
        class="content-card-result seleccionable"
      >
        <div @click="PressIncident(item)">
          <f7-card-header>
            <div class="display-flex">
              <div :class="[item.Tipo === 1 ? 'btn-oval-naranja-12' : 'btn-oval-azulOscuro-12']" />
              <div class="padding-left-half">
                <span v-if="item.Tipo === TipoIncidencia.AUMENTO">
                  {{
                    $t('production.manageProductionLines.incidentsPopup.types.increase', {
                      serial: item.LineaPedidoVenta.PedidoVenta.Serie,
                      number: item.LineaPedidoVenta.PedidoVenta.Numero,
                      order: item.LineaPedidoVenta.Orden,
                    })
                  }}
                </span>
                <span v-if="item.Tipo === TipoIncidencia.DISMINUCION">
                  {{
                    $t('production.manageProductionLines.incidentsPopup.types.decrease', {
                      serial: item.LineaPedidoVenta.PedidoVenta.Serie,
                      number: item.LineaPedidoVenta.PedidoVenta.Numero,
                      order: item.LineaPedidoVenta.Orden,
                    })
                  }}
                </span>
                <span v-if="item.Tipo === TipoIncidencia.CAMBIOENVASE">
                  {{
                    $t('production.manageProductionLines.incidentsPopup.types.packageChange', {
                      serial: item.LineaPedidoVenta.PedidoVenta.Serie,
                      number: item.LineaPedidoVenta.PedidoVenta.Numero,
                      order: item.LineaPedidoVenta.Orden,
                    })
                  }}
                </span>
              </div>
            </div>
          </f7-card-header>
          <f7-card-content class="padding-right-half padding-vertical-half">
            <div class="card-content-info">
              <div class="card-content-info__title">
                {{ item.Mensaje }}
              </div>
            </div>
          </f7-card-content>
        </div>
      </f7-card>
    </div>

    <f7-actions
      id="actions-PCIncidenciasPedidosPlanificados"
      class="content-action-sheet-incidencias"
      :opened="incidencesActionsOpened"
      @actions:closed="incidencesActionsOpened = false"
    >
      <f7-block>
        <div>
          <!-- Aumentos y disminuciones de palés en la linea de pedido -->
          <div
            v-if="selectedIncident != null
              && (selectedIncident.Tipo === TipoIncidencia.AUMENTO
                || selectedIncident.Tipo === TipoIncidencia.DISMINUCION)"
          >
            <div class="content-action-sheet-incidencias__search text-align-center">
              <UCSearchEntityERP
                ref="UCSearchEntityLine"
                :title="$t('common.productionLine').toUpperCase()"
                :placeholder="$t('searchEntity.line.placeholder.selectProductionLine')"
                :search-text="$t('searchEntity.line.searchText')"
                :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
                :min-text-search="0"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :emit-evet-change-default-value="true"
                :default-value="productLineUpdated"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :default-etities-list="defaultEntitiesFor"
                @open-popup-search-entities="incidencesActionsOpened = false"
                @close-popup-search-entities="incidencesActionsOpened = true"
                @selection="EventselectedLine"
              />
            </div>
          </div>
          <!-- Unidades por envase modificada en la linea de pedido -->
          <div
            v-if="selectedIncident != null
              && selectedIncident.Tipo === TipoIncidencia.CAMBIOENVASE"
          >
            <span>
              {{
                $t('production.manageProductionLines.incidentsPopup.confirmationText', {
                  incidentMessage: selectedIncident.Mensaje,
                })
              }}

            </span>
          </div>
          <div class="content-action-sheet-incidencias__buttons">
            <a
              class="color-red"
              @click="CancelSelected()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
            <a
              class="color-blue"
              @click="ConfirmationSelected()"
            >
              {{ $t('common.confirm').toUpperCase() }}
            </a>
          </div>
        </div>
      </f7-block>
    </f7-actions>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { TipoIncidenciaPlanificacionLineaPedidoVenta } from '@/js/services/traceability/enumeradosTA';

import { sleep } from '@/js/utils/sleep';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';

/**
 * @import {
 * GestionIncidenciaPlanificacionLineaPedidoVenta,
 * } from '@erpagroapp/types' */

export default {
  name: 'PCIncidenciasPedidosPlanificacion',
  components: {
    UCSearchEntityERP,
  },
  props: {
    productionLine: {
      default: null,
      type: Object,
    },
    automaticUpdateInterval: {
      type: Number,
      default: 0,
    },
  },

  emits: [
    'incidence',
    'change',
  ],

  data() {
    return {
      automaticUpdater: null,
      productLineUpdated: null, // linea de produccion actual
      incidentsCurrentLine: [], // Incidencias de la linea actual
      selectedIncident: null, // incidencia seleccionada
      defaultEntitiesFor: null, // array que le pasamos al UCSearchENtityepr
      lineSelected: null,
      /** Whether the actions should be opened. */
      incidencesActionsOpened: false,
    };
  },
  computed: {
    TipoIncidencia() {
      return TipoIncidenciaPlanificacionLineaPedidoVenta;
    },
  },
  watch: {
    productionLine(val) {
      this.productLineUpdated = val;
      if (val != null) {
        this.GetIncidenciasPlanificacion(this.productLineUpdated.Id);
      } else {
        this.$emit('incidence', 0);
      }
    },
  },

  created() {
    this.StartComponent();
  },
  unmounted() {
    this.DestroyComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.UpdateMainData();
      if (this.automaticUpdateInterval !== 0) {
        this.automaticUpdater = setInterval(
          () => {
            this.UpdateMainData();
          },
          this.automaticUpdateInterval * 1000,
        );
      }
      this.productLineUpdated = this.productionLine;
      this.GetIncidenciasPlanificacion(this.productLineUpdated.Id);
    },
    DestroyComponent() {
      Log(this, this.DestroyComponent.name);
      clearInterval(this.automaticUpdater);
    },
    /** @public */
    UpdateMainData() {
      Log(this, this.UpdateMainData.name);
      // Si se retornan incidencias emitira el evento "incidence" con el número de incidencias (1, 2 ,3 )
      if (this.productLineUpdated !== null) {
        this.GetIncidenciasPlanificacion(this.productLineUpdated.Id);
      } else {
        this.$emit('incidence', null);
      }
    },
    EventselectedLine(obj) {
      Log(this, this.EventselectedLine.name);
      this.lineSelected = obj;
    },
    PressIncident(val) {
      this.incidencesActionsOpened = true;
      this.selectedIncident = val;
      this.defaultEntitiesFor = this.selectedIncident.LineasProduccion;
      if (this.selectedIncident.Tipo === this.TipoIncidencia.AUMENTO || this.selectedIncident.Tipo === this.TipoIncidencia.DISMINUCION) {
        sleep(10).then(() => {
          this.$refs.UCSearchEntityLine.Clear({
            autoFocus: false,
            noEmitEvent: true,
          });
          this.$refs.UCSearchEntityLine.SelectEntity(this.productionLine);
        });
      }
    },
    CancelSelected() {
      Log(this, this.CancelSelected.name);
      this.incidencesActionsOpened = false;
    },
    async ConfirmationSelected() {
      Log(this, this.ConfirmationSelected.name);
      /** @type {GestionIncidenciaPlanificacionLineaPedidoVenta} */
      const objSend = {
        LineaPedidoVenta: this.selectedIncident.LineaPedidoVenta,
        ParteProduccion: this.selectedIncident.ParteProduccion,
        TipoIncidencia: this.selectedIncident.Tipo,
        CantidadPales: 0,
      };
      let result = null;
      switch (this.selectedIncident.Tipo) {
        case this.TipoIncidencia.AUMENTO:
        case this.TipoIncidencia.DISMINUCION:
          // const lineNewRepart = this.lineSelected;
          if (!this.ValidateE7(this.lineSelected)) {
            HiNotification.Toast(this.$t('production.manageProductionLines.incidentsPopup.confirmation.lineNotSelectedToastText'));
            return;
          }
          HiDialog.Preloader(true, this.$t('common.updatingQuantities'), false);
          objSend.LineaProduccion = this.lineSelected;
          objSend.CantidadPales = this.selectedIncident.CantidadPalesPendientesAsignar;
          result = await this.GestionarIncidenciasPlanificacionLineaPedidoVenta([objSend]);
          HiDialog.Preloader(false);
          break;
        case this.TipoIncidencia.CAMBIOENVASE:
          objSend.LineaProduccion = this.productionLine;
          HiDialog.Preloader(true, this.$t('production.manageProductionLines.incidentsPopup.confirmation.preloaderTextChangePackage'), false);
          result = await this.GestionarIncidenciasPlanificacionLineaPedidoVenta([objSend]);
          HiDialog.Preloader(false);
          break;
        default:
          LogError(this, 'Incidencia sin definición de tipo');
          break;
      }
      this.incidencesActionsOpened = false;
      if (result) {
        this.$emit('change');
      }
      this.GetIncidenciasPlanificacion(this.productLineUpdated.Id);
    },

    // ValidateE7 - No se ha indicado línea de producción .
    ValidateE7(newLine) {
      Log(this, this.ValidateE7.name);
      if (newLine === null || newLine === '') {
        return false;
      }
      return true;
    },

    async GestionarIncidenciasPlanificacionLineaPedidoVenta(lstResolution) {
      Log(this, this.GestionarIncidenciasPlanificacionLineaPedidoVenta.name);
      const res = await ConexionTA.callGestionarIncidenciasPlanificacionLineaPedidoVenta(lstResolution).then((result) => {
        if (result.Valor) {
          if (result.Mensaje !== '') {
            HiNotification.Toast(result.Mensaje);
          }
          return true;
        }
        HiNotification.Toast(result.Mensaje);
        return false;
      });
      return res;
    },

    GetIncidenciasPlanificacion(idLineaProduccion) {
      Log(this, this.GetIncidenciasPlanificacion.name);

      ConexionTA.callObtenerIncidenciasPlanificacion(idLineaProduccion).then((result) => {
        if (result.Valor) {
          this.incidentsCurrentLine = JSON.parse(result.Mensaje);
          this.$emit('incidence', this.incidentsCurrentLine.length);
        } else {
          this.incidentsCurrentLine = [];
          this.$emit('incidence', 0);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-pcIncidenciasPedidosPlanificacion {
  .content-card-list {
    height: calc(100vh - 40vh);
    overflow-y: scroll;
  }

  .content-card-result {
    .card-header {
      --f7-card-header-min-height: 36px;
      --f7-card-header-padding-horizontal: 8px;
    }

    .card-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .card-content-info {
        &__title {
          color: #172b4d;
          font-size: 18px;
          font-weight: 500;
        }

        &__subtitle {
          color: var(--his-kiwi-pulp);
          font-size: 16px;
          font-weight: 400;
        }

        &__footer {
          color: var(--his-darkgray);
          font-size: 12px;
          font-weight: 400;
          margin-top: 10px;
        }
      }

      .card-content-action {
        display: flex;
        align-self: flex-start;
        cursor: pointer;
      }
    }
  }

  .btn-oval-azulOscuro-12 {
    background-color: var(--his-steel-blue);
    box-shadow: 0 4px 8px 0 rgb(42 55 71 / 15%);
    border: 1px solid var(--his-steel-blue);
    border-radius: 17px;
    width: 12px;
    height: 12px;
    min-height: 12px;
    min-width: 12px;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .btn-oval-naranja-12 {
    background-color: var(--his-mandarina);
    box-shadow: 0 4px 8px 0 rgb(42 55 71 / 15%);
    border: 1px solid #db921c;
    border-radius: 17px;
    width: 12px;
    height: 12px;
    min-height: 12px;
    min-width: 12px;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}

.content-action-sheet-incidencias {
  background-color: #fff;

  &__search {
    padding-bottom: 5vh;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      font-size: 14px;
      font-weight: 500;
    }
  }

  .actions-label::after {
    height: 0 !important;
  }
}
</style>
